import { render, staticRenderFns } from "./iFrameSignin.vue?vue&type=template&id=39a236b2&scoped=true"
import script from "./iFrameSignin.vue?vue&type=script&lang=js"
export * from "./iFrameSignin.vue?vue&type=script&lang=js"
import style0 from "./iFrameSignin.vue?vue&type=style&index=0&id=39a236b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a236b2",
  null
  
)

export default component.exports